import styled, { keyframes } from 'styled-components'

// COMMON

export const PaymentCCContainer = styled.div`
  /* padding-top: 70px; */
  background-color: ${({ theme }) => theme.MainBackGround};
  height: 100vh;
  height: 100dvh;
  width: 100vw;
`

export const OverwiewContainer = styled.div`
  height: calc(100% - 70px - 15px);
`

export const CartContainer = styled.div`
  height: calc(100% - 100px - 120px);
  flex: 1;
  overflow-y: auto;
`

export const FooterContainer = styled.div`
  /* position: fixed;
  top: calc(100% - 120px); */
  /* left: 0;
  right: 0; */
  width: 100vw;
  padding: 10px 20px 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 50px;
  grid-gap: 10px;
  background-color: ${({ theme }) => theme.FooterColor};
  color: ${({ theme }) => theme.FontColor};
  /* box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.15); */
  border-top: 1px solid #ffffff40;
  height: 120px;
  /* width: 100%; */

  & button {
    height: 50px !important;
  }
`

export const Total = styled.div`
  grid-row: 1 / 2;
  grid-column: 1 / -1;
  height: 30px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  span {
    line-height: 30px;
    font-size: 17px;
    font-weight: 500;
  }
  span:last-child {
    font-weight: 600;
    margin-left: 15px;
  }
`

export const SpinnerContainer = styled.div`
  position: absolute;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  top: 0;
  & div {
    width: unset;
    margin: unset;
  }
`

// LOGIN

export const LoginSuggestionContainer = styled.div`
  height: 100%;
  width: 100vw;
  background-color: ${({ theme }) => theme.MainBackGround};

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.FontColor};

  gap: 25px;
`

export const DontHaveAccountText = styled.p`
  text-decoration: underline;

  font-weight: 400;
  font-style: Regular;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-thickness: 0%;

  margin-top: -10px;
`

export const LoginToProceedText = styled.p`
  font-weight: 600;
  font-style: SemiBold;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  width: 270px;
  height: 44px;
`

// Credentials

export const CredentialsContainer = styled(LoginSuggestionContainer)`
  display: flex;
  justify-content: space-between;

  text-align: center;
  width: 75vw;
  margin: 0 auto;

  height: calc(100% - 70px - 100px - 15px);
`

export const CredentialsContainerInnerFirst = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  flex: 1;
  overflow-y: auto;
`

export const CredentialsContainerInnerSecond = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  flex-shrink: 0;
`

export const IdDescription = styled.p`
  margin-top: -20px;
  margin-bottom: 20px;
`

export const TermsAndConditionsContainer = styled.div`
  /* position: fixed;
  top: calc(100% - 120px - 75px); */

  width: 100vw;
  padding: 0 10vw;
  justify-self: center;
  p {
    font-size: 13px;
    text-align: left;
  }
  b {
    text-decoration: underline;
    color: ${({ theme }) => theme.colour};
  }
`

// RESULT

const IconAnimation = keyframes`
  0%
  {
    transform: scale(0.1);
    opacity: 0.1;
  }
  100%
  {
    transform: scale(1);
    opacity: 1;
  }
`

export const ResultIcon = styled.img`
  animation: ${IconAnimation} 1s ease-out forwards;
  stroke: green;
  fill: red;
`

export const ResultIconContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  height: 100dvh;

  display: flex;
  justify-content: center;
  align-items: center;
`

const CrossIconAnimation = keyframes`
  0%
  {
    transform: scale(1);
    opacity: 0.1;
  }
  100%
  {
    transform: scale(15);
    opacity: 1;
  }
`

export const CrossContainer = styled.div`
  animation: ${CrossIconAnimation} 1s ease-out forwards;
`

export const ButtonContainer = styled.div`
  position: fixed;
  left: 10vw;
  bottom: 10vw;
`

export const OrderCommentLabel = styled.p`
  margin: 0 0 -10px;
  text-align: left;
  font-size: 14px;
  opacity: 0.8;
`
